module.exports = __webpack_public_path__ + "images/emoji/fu.23e2a534c229af8fb917.png";